import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faTiktok,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { socialMediaLinks } from "../../data/SocialMediaLinks";
import { device } from "../../theme/Breakpoints";
import { Color } from "../../theme/Color";
import { FontSizes } from "../../theme/FontSize";
import AppGrid from "../Grid/App";
import Heading from "../Heading";
import Logo from "../Logo";
import Newsletter from "../Newsletter";
import PageSection from "../PageSection";
import Spacer from "../Spacer";

const StyledFooterCol = styled(Col)`
  margin-bottom: 6rem;
  padding: 0rem 2rem 0rem 2rem;

  @media ${device.mdAndWider} {
    margin: 0;
  }
`;

const StyledFooterLink = styled(Row)`
  font-size: ${FontSizes[-1]};
  & a {
    display: block;
    color: ${Color.White};
    padding: 0.2rem 0;
    margin: 0.3rem 0;
    text-decoration: none;
  }
  & a:hover,
  & a span:hover {
    text-decoration: underline;
  }
  & span {
    display: inline-block;
    margin-left: 1rem;
  }
`;

const StyledSmallprintRow = styled(Row)`
  font-size: ${FontSizes[-1]};
  text-align: center;

  color: ${Color.Grey2};

  & a {
    color: ${Color.Blue6};
    text-decoration: underline;
  }
`;

const PublicFooter = () => {
  return (
    <>
      <div style={{ backgroundColor: Color.Orange5 }}>
        <AppGrid>
          <PageSection backgroundColor={Color.Orange5}>
            <Col xs={12}>
              <Spacer top={4} bottom={3}>
                <Row center="xs">
                  <StyledFooterCol xs={12} md={4} lg={2}>
                    <Row center="xs" middle="xs">
                      <Logo />
                    </Row>
                    <Row center="xs" style={{ margin: "3rem 0 1rem 0" }}>
                      <Link href="/pwa/install-on-iphone">
                        <img
                          src="/img/buttons/iphone.svg"
                          height="38"
                          style={{
                            cursor: "pointer",
                          }}
                        />
                      </Link>
                    </Row>
                    <Row center="xs">
                      {" "}
                      <Link href="/pwa/install-on-android">
                        <img
                          src="/img/buttons/google-play.svg"
                          height="38"
                          style={{ cursor: "pointer" }}
                        />
                      </Link>
                    </Row>
                  </StyledFooterCol>

                  {/* Footer Menu 1 */}
                  <StyledFooterCol xs={6} md={4} lg={8 / 3}>
                    <Row center="xs">
                      <Col xs={11}>
                        <Row start="md">
                          <Heading fontColor={Color.White}>
                            Valmeego is for
                          </Heading>
                        </Row>
                        <StyledFooterLink>
                          <Link href="/explore-ireland">
                            <a>Exploring Ireland</a>
                          </Link>
                        </StyledFooterLink>
                        <StyledFooterLink>
                          <Link href="/personal">
                            <a>Travelling</a>
                          </Link>
                        </StyledFooterLink>
                        <StyledFooterLink>
                          <Link href="/ameegos">
                            <a>Local Advisors (Ameegos)</a>
                          </Link>
                        </StyledFooterLink>
                        <StyledFooterLink>
                          <Link href="/destination-promoters">
                            <a>Local Destinations</a>
                          </Link>
                        </StyledFooterLink>
                        <StyledFooterLink>
                          <Link href="/business">
                            <a>Local Businesses</a>
                          </Link>
                        </StyledFooterLink>
                      </Col>
                    </Row>
                  </StyledFooterCol>

                  {/* Footer Menu 2 */}
                  <StyledFooterCol xs={6} md={4} lg={8 / 3}>
                    <Row center="xs">
                      <Col xs={11}>
                        <Row start="md">
                          <Heading fontColor={Color.White}>Find Us On</Heading>
                        </Row>
                        <StyledFooterLink>
                          <Link href={socialMediaLinks.facebook}>
                            <a>
                              <FontAwesomeIcon icon={faFacebook} />
                              <span>Facebook</span>
                            </a>
                          </Link>
                        </StyledFooterLink>
                        <StyledFooterLink>
                          <Link href={socialMediaLinks.instagram}>
                            <a>
                              <FontAwesomeIcon icon={faInstagram} />
                              <span>Instagram</span>
                            </a>
                          </Link>
                        </StyledFooterLink>
                        <StyledFooterLink>
                          <Link href={socialMediaLinks.twitter}>
                            <a>
                              <FontAwesomeIcon icon={faXTwitter} />
                              <span>Twitter</span>
                            </a>
                          </Link>
                        </StyledFooterLink>
                        <StyledFooterLink>
                          <Link href={socialMediaLinks.linkedIn}>
                            <a>
                              <FontAwesomeIcon icon={faLinkedin} />
                              <span>Linkedin</span>
                            </a>
                          </Link>
                        </StyledFooterLink>
                        <StyledFooterLink>
                          <Link href={socialMediaLinks.youTube}>
                            <a>
                              <FontAwesomeIcon icon={faYoutube} />
                              <span>YouTube</span>
                            </a>
                          </Link>
                        </StyledFooterLink>
                        <StyledFooterLink>
                          <Link href={socialMediaLinks.tiktok}>
                            <a>
                              <FontAwesomeIcon icon={faTiktok} />
                              <span>TikTok</span>
                            </a>
                          </Link>
                        </StyledFooterLink>
                      </Col>
                    </Row>
                  </StyledFooterCol>

                  {/* Newsletter */}
                  <StyledFooterCol
                    xs={12}
                    md={12}
                    lg={4}
                    style={{ marginBottom: "2rem" }}
                  >
                    <Newsletter />
                  </StyledFooterCol>
                </Row>
              </Spacer>
            </Col>
          </PageSection>
        </AppGrid>
      </div>

      {/* Smallprint */}
      <AppGrid>
        <PageSection backgroundColor={Color.White}>
          <Row center="xs">
            <Spacer all={2}>
              <Col xs={12}>
                <StyledSmallprintRow center="xs">
                  <p>
                    All content copyright Valmeego Ltd. unless otherwise stated.
                    Registered in Ireland Company number 616942.{" "}
                    <a href="/terms-of-use">Terms of use</a>.{" "}
                    <a href="/privacy-policy">Privacy policy</a>.{" "}
                    <a href="/cookie-policy">Cookie policy</a>.{" "}
                    <a href="/photo-credits">Photo credits</a>.{" "}
                  </p>
                </StyledSmallprintRow>
              </Col>
            </Spacer>
          </Row>
        </PageSection>
      </AppGrid>
    </>
  );
};

export default PublicFooter;
